package b2d

import abilities.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.view.*
import com.soywiz.korim.color.*
import org.jbox2d.collision.shapes.*
import org.jbox2d.dynamics.*

object AbilityObjectFactory {

    const val FIRE_BOLT_RADIUS = 14.0

    fun Container.buildFireBolt(
        posX: Float,
        posY: Float,
        sprite: Sprite,
        fireBolt: FireBolt,
        world: World
    ): Container {
        return this.container {
            circle(FIRE_BOLT_RADIUS, Colors.ORANGE)
                .position(-FIRE_BOLT_RADIUS, -FIRE_BOLT_RADIUS)
                .apply {
                    addChild(sprite)
                }
        }.position(posX, posY)
            .registerBodyWithFixture(
                world = world,
                type = BodyType.DYNAMIC,
                fixedRotation = true,
                allowSleep = false,
                restitution = 0,
                gravityScale = 0,
                density = 0,
                isSensor = false,
                shape = CircleShape(FIRE_BOLT_RADIUS / world.customScale),
                bullet = true
            ).apply {
                body?.getFixtureList()?.filterData?.set(Filter().apply {
                    categoryBits = B2dParameters.FIRE_BOLT_BIT
                    maskBits = B2dParameters.GROUND_BIT or
                        B2dParameters.PLAYER_BIT
                })

                body?.getFixtureList()?.userData = fireBolt

                body?.fixture {
                    this.shape = CircleShape(FIRE_BOLT_RADIUS * 3 / world.customScale)
                    this.isSensor = true
                    this.friction = 0f
                    this.restitution = 0f
                    this.density = 0f
                    this.filter = Filter().apply {
                        categoryBits = B2dParameters.FIRE_BOLT_SENSOR_BIT
                        maskBits = B2dParameters.PLAYER_BIT
                    }
                    userData = fireBolt
                }
            }
    }
}
